import React, { Component } from 'react';
import {Container} from '../../components/Container/Container';
import {FaqListItem, FaqListContent, FaqListTitle, TotalSearchedItems, NoResultsFoundWrapper} from './FaqListComponents';
import {CommonUtils} from '../../utils/CommonUtils';
import {HelpcenterClient} from '../../utils/HelpcenterClient';
import { withRouter } from 'react-router-dom';
import { NoResultsFoundSvg } from '../../assets/svgAssets';
import { HelpCenterData } from '../../context/HelpcenterDataContext';

class FaqList extends Component {
    static contextType = HelpCenterData;
    constructor(props){
        super(props);
        this.state = {
            faqList : [],
            appId : "",
            companyName: "Kommunicate",
            searchQuery:"",
            isSearchFinished: false
        };
    };

  // Function to check if content starts with table tag
  startsWithTable = (html) => {
    return html.trim().toLowerCase().startsWith('<table');
  };

  // Function to extract content from first tag
  extractFirstTagContent = (html) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    const firstChild = tempDiv.firstElementChild;
    return firstChild ? firstChild.textContent : '';
  };

  //Following function will remove all the html tags and will return plain text
  stripHtml = (html) => {
    if (!html) return '';
    
    if (this.startsWithTable(html)) {
      return 'Table Content';
    }
    
    return this.extractFirstTagContent(html);
  };

    populateAllFaq = () => {
        this.clearFaqList();
        HelpcenterClient.getAllFaq(this.context.helpCenter.appId).then(response => {
            response && this.setState({
                faqList: response,
                searchQuery: ''
            })
        })
    }
    populateSearchedFaq = () => {
        this.clearFaqList();
        this.setState({
            searchQuery: CommonUtils.getUrlParameter(window.location.search, "q")
        }, () => {
            HelpcenterClient.searchFaq(this.context.helpCenter.appId, this.state.searchQuery).then(response => {
                response && response.data && this.setState({
                    faqList: response.data.filter( value => value !== null),
                    isSearchFinished: true
                })
            }).catch(err =>{
                console.log(err);
            })
        })
    }
    openFaqArticle = (query) =>{
        this.props.history.push({
            pathname: '/article/' + CommonUtils.formatFaqQuery(query)
        });
    }
    componentDidMount = () => {
        if (window.location.pathname.indexOf('category') > 0) {
            this.setState({
                categoryQuery: decodeURIComponent(window.location.pathname.replace('/category/', ''))
            }, () => {
                let params = {
                    categoryName: this.state.categoryQuery,
                    applicationId : this.context.helpCenter.appId,
                    status: 'published',
                    type: 'faq'
                  }
                HelpcenterClient.getFaqFromCategory(params).then(response => {
                    response && response.data && response.data.data && this.setState({
                        faqList: response.data.data.faq.filter(value => value !== null),
                        isSearchFinished: true
                    })
                }).catch(err => {
                    console.log(err);
                })
            })

       }else{
            this.setState({
                searchQuery :  CommonUtils.getUrlParameter(window.location.search,"q"),
            },()=>{
                this.state.searchQuery ? this.populateSearchedFaq() : this.populateAllFaq();
            })
       }
    }
    clearFaqList = () =>{
        this.setState({
            faqList : [],
            isSearchFinished: false
        })
    }
    componentDidUpdate = (prevProps, prevState) => {
      prevProps.location.search !== this.props.location.search && CommonUtils.getUrlParameter(window.location.search,"q") ? this.populateSearchedFaq() : (prevProps.location.key !== this.props.location.key && !CommonUtils.getUrlParameter(window.location.search,"q")) && this.populateAllFaq();
    }
    
    
    render() {
        return (
                <Container className="animated slide-animated">
                {   
                    this.state.searchQuery &&
                    (this.state.faqList.length ?
                    <TotalSearchedItems>{this.state.faqList.length} {this.state.faqList.length > 1 ? 'results' : 'result'  } found for : <span>{this.state.searchQuery}</span></TotalSearchedItems> 
                        :  this.state.isSearchFinished &&
                        <NoResultsFoundWrapper>
                            <NoResultsFoundSvg/>
                                <span>NO RESULT FOUND</span>
                                <span>We couldn’t find what you’re looking for</span>
                        </NoResultsFoundWrapper> )
                }
                {
                    this.state.faqList && this.state.faqList.map((index,data)=> (
                            
                                <FaqListItem id={"faq-list-item-" + data} key={index.id} onClick={e=>{this.openFaqArticle(index.name)}}>
                                    <FaqListTitle id={"faq-list-item-" + data + "-title"}>{index.name}</FaqListTitle>
                                    <FaqListContent id={"faq-list-item-" + data + "-content"}>{this.stripHtml(index.content)}</FaqListContent>
                            </FaqListItem>
                        
                    ))
                }
                </Container>
        )
    }
}
FaqList.contextType = HelpCenterData;
export default Object.assign(withRouter(FaqList), { contextType: undefined });